import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {MatIconButton} from "@angular/material/button";
import {CdkDrag, CdkDragHandle} from "@angular/cdk/drag-drop";
import {ToleranceDto, ToleranceViewerDto} from "../../models/viewmodels/tolerance-viewer-dto.model";
import {ToleranceTableComponent} from "./tolerance-table/tolerance-table.component";
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'colimo-tolerance-dialog',
  templateUrl: './tolerance-dialog.component.html',
  imports: [
    ToleranceTableComponent,
    TranslateModule,
    MatIcon,
    MatDialogTitle,
    MatDialogContent,
    MatDialogClose,
    MatIconButton,
    CdkDrag,
    CdkDragHandle
  ],
  styleUrl: './tolerance-dialog.component.scss'
})
export class ToleranceDialogComponent implements OnInit {
  public titleBatchTable: string;
  public titleLineTable: string;

  public displayedColumns: string[] = ['colorSystem', 'geo', 'lowL', 'L', 'lowAC', 'AC', 'lowBH', 'BH'];
  public headerColumns: string[] = ['tableTitle'];
  public batchTols: ToleranceDto[];
  public lineTols: ToleranceDto[];

  constructor(private dialogRef: MatDialogRef<ToleranceDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
              public data: {
                toleranceData: ToleranceViewerDto
              }) {
    this.batchTols = [];
    this.lineTols = [];
  }

  public ngOnInit(): void {
    this.titleBatchTable = (this.data.toleranceData.specialColoring ? 'Green tolerances' : 'Batch tolerances');
    this.titleLineTable = (this.data.toleranceData.specialColoring ? 'Red tolerances' : 'Line tolerances');
    if (!this.data.toleranceData.specialColoring) {
      this.displayedColumns.push('dEGreen', 'dERed');
      this.headerColumns.push('limitsDE');
    }
    this.populateTableData();

    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });

  }

  private populateTableData(): void {
    this.data.toleranceData.tolerances.forEach(t => {
      if (t.toltyp === 'C') {
        this.batchTols.push(t);
      }
      if (t.toltyp === 'S') {
        this.lineTols.push(t);
      }
    })
  }
}
